/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BalanceDTO } from './BalanceDTO';
import type { LimitsDTO } from './LimitsDTO';

export type WalletBalanceInfoResponseDTO = {
    accountFreezeStatus?: string;
    balance?: BalanceDTO;
    externalAccountNumber?: string;
    /**
     * Message describing the account freeze status
     */
    freezeStatusMessage?: string;
    isBusinessSectorCompleted?: boolean;
    isRegistrationCompleted?: boolean;
    isUpgradeTierEnabled?: boolean;
    limits?: LimitsDTO;
    percentageCollected?: string;
    /**
     * Registration type from the merchant's onboarding record. Clients route on it to choose the facial or plain path; null for records that predate the field.
     */
    registrationType?: WalletBalanceInfoResponseDTO.registrationType;
    showWallet?: boolean;
    tierType?: WalletBalanceInfoResponseDTO.tierType;
    walletId?: string;
};

export namespace WalletBalanceInfoResponseDTO {

    /**
     * Registration type from the merchant's onboarding record. Clients route on it to choose the facial or plain path; null for records that predate the field.
     */
    export enum registrationType {
        INDIVIDUAL = 'INDIVIDUAL',
        SOLE_PROPRIETORSHIP = 'SOLE_PROPRIETORSHIP',
        LIMITED_LIABILITY = 'LIMITED_LIABILITY',
        NGO_NPO = 'NGO_NPO',
        GOVERNMENT = 'GOVERNMENT',
        PARTNERSHIP_INCORPORATED_TRUSTEES = 'PARTNERSHIP_INCORPORATED_TRUSTEES',
        CLUBS_SOCIETIES_ASSOCIATIONS = 'CLUBS_SOCIETIES_ASSOCIATIONS',
        COOPERATIVE_SOCIETIES = 'COOPERATIVE_SOCIETIES',
    }

    export enum tierType {
        BRONZE = 'BRONZE',
        SILVER = 'SILVER',
        GOLD = 'GOLD',
        PLATINUM = 'PLATINUM',
        CORPORATE = 'CORPORATE',
    }


}

